const getFlatMap = (o: any, prefix = ""): any =>
  Object.entries(o).flatMap(([k, v]) =>
    Object(v) === v ? getFlatMap(v, `${prefix}${k}.`) : [[`${prefix}${k}`, v]]
  );

export default getFlatMap;
